/*
Akhila 04/18/2023 3225736869 rename client Number to client code and rearrange
Ravi 04/26/2023 3225736869 set bydefault from corporate to  Department
Ravi 06/14/2023 3225736869 rename Revone to RevOne
Ravi 06/16/2023 3225736869 rename Company to companies
Sohel 12/07/2023 3225736869 Fixed default Search Issue
Sohel 12/07/2023 3225736869 Fixed Type field Search Issue
Sohel 12/07/2023 3225736869 Fixed Organization Type Reset Button Issue
*/
import React, {useContext, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {
  Button,
  Grid,
  TextField,
} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {ThemeContext} from '../../../themes/ThemeProvider';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import {
  fetchCompanyDropDownData,
  fetchCorporateDropDownData,
  fetchSiteDropDownData,
  fetchClientClassData,
  fetchServiceIdData,
  resetEditData,
  fetchInvoiceTypeDropDownData,
  fetchDropDowns,
  fetchClientNumberDropDownData,
} from '../../../redux/reducers/clientMangement/Organizaation';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import ResultsTable from '../ResultsTable';
import {TENANTS_REVONE_COMPANIES} from '../../../constants/ReusableConstants';
import { Autocomplete } from '@material-ui/lab';

const orgTypes = [
  {label: 'Corporate', value: 'Corporate'},
  {label: 'Site', value: 'Site'},
  {label: 'Department', value: 'Service-Client'},
  {label: 'RevOne Companies', value: 'Company'},
];

const Organization = ({
  setTabValue,
  setOrgType,
  setId,
  setSiteTableData,
  organizationAccess,
  setEdit,
  tenants,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const [searchData, setSearchData] = useState({});
  const dispatch = useDispatch();
  const classes = reusableInputStyles();
  const [isSubmit, setSubmit] = useState(false);
  const {
    corporateAPIdata,
    companyAPIdata,
    siteAPIdata,
    status,
    dropDownData,
    clientNumberAPIdata,
  } = useSelector(({organization}) => organization);

  const searchOrganization = tenants ?
    'Company' :
    !tenants && sessionStorage.getItem('orgType') === 'Company' ?
      'Service-Client' :
      sessionStorage.getItem('orgType') ?
        sessionStorage.getItem('orgType') :
        '';
  const StatusOptions = [
    {key: 'A', value: 'All'},
    {key: 'Y', value: 'Active'},
    {key: 'N', value: 'InActive'},
  ];

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.value === option) {
          label = item;
        }
      });
    return label;
  };

  const initialValues = {
    // organizationType: dropDownData?.ORG_TYPE[0]?.value || "",
    organizationType: tenants ?
      orgTypes[3] :
      searchOrganization ?
        getObject(searchOrganization, orgTypes) :
        orgTypes[2],
    corporateName: '',
    companyName: '',
    siteName: '',
    clientName: '',
    clientNumber: '',
    clientClass: '',
    status: {key: 'A', value: 'All'},
  };

  useEffect(() => {
    setEdit(false);
  }, []);

  useEffect(() => {
    setSearchData({
      ...initialValues,
      organizationType: tenants ?
        orgTypes[3] :
        searchOrganization ?
          getObject(searchOrganization, orgTypes) :
          orgTypes[2],
    });
  }, [searchOrganization]);

  useEffect(() => {
    dispatch(fetchDropDowns());
    dispatch(fetchCompanyDropDownData());
    dispatch(fetchClientNumberDropDownData());
    dispatch(fetchCorporateDropDownData());
    dispatch(fetchSiteDropDownData());
    dispatch(fetchClientClassData());
    dispatch(fetchServiceIdData());
    dispatch(resetEditData());
    dispatch(fetchInvoiceTypeDropDownData());
    setSearchData(initialValues);
  }, [dispatch]);
  useEffect(() => {
    if (status === 200) {
      dispatch(fetchCompanyDropDownData());
      dispatch(fetchCorporateDropDownData());
      dispatch(fetchSiteDropDownData());
      dispatch(fetchClientNumberDropDownData());
    }
  }, [status]);

  const handleSubmit = (data) => {
    const values = {
      ...data,
      organizationType: tenants ?
        {label: 'RevOne Companies', value: 'Company'} :
        data.organizationType,
    }
    setSearchData(values);
    if(!tenants){
      sessionStorage.setItem('ClientManagement', JSON.stringify(values));
    } else if(tenants){
      sessionStorage.setItem('Tenants', JSON.stringify(values));
    }
    setSubmit(true);
  };
  const searchSessionClientManagement = JSON.parse(
    sessionStorage.getItem('ClientManagement'),
  );
  const searchSessionTenants = JSON.parse(
    sessionStorage.getItem('Tenants'),
  );
  return (
    <>
      <div className={classes.addRule}>
        <div>
          {tenants ? (
            <h2 className="search-title">Tenants Search</h2>
          ) : (
            <h2 className="search-title">Client Search</h2>
          )}
          <Formik onSubmit={handleSubmit} initialValues={searchSessionClientManagement && !tenants ?
            searchSessionClientManagement : searchSessionTenants && tenants ? searchSessionTenants :
              initialValues} enableReinitialize>
            {(props) => {
              const {
                values,
                handleChange,
                setFieldValue,
                handleBlur,
                touched,
                errors,
              } = props;
              return (
                <div>
                  <Form autoComplete="off" noValidate>
                    <div>
                      <ErrorBoundaryForComponents>
                        <Grid
                          container
                          className="global-field-textfields new-standard-textfields"
                          spacing={2}
                        >
                          {!tenants ? (
                            <Grid item xs={3} md={4} className="form-group">
                              <Autocomplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="organizationType"
                                id="organizationType"
                                size="small"
                                filterOptions={(options, params) => {
                                  const filtered = options?.filter((i) => i?.value !== 'Company');
                                  return [...filtered];
                                }}
                                value={values.organizationType}
                                options={orgTypes}
                                getOptionLabel={(option) => option?.label}
                                onChange={(e, value) => {
                                  setFieldValue('organizationType', value || orgTypes[2]);
                                  setFieldValue('corporateName', {});
                                  setFieldValue('companyName', {});
                                  setFieldValue('siteName', {});
                                  setFieldValue('clientName', '');
                                  setFieldValue('clientNumber', '');
                                  setFieldValue('clientClass', '');
                                  const newValues = {
                                    ...values,
                                    corporateName: '',
                                    companyName: '',
                                    siteName: '',
                                    clientName: '',
                                    clientNumber: '',
                                    clientClass: '',
                                    organizationType: value || orgTypes[2],
                                  };
                                  setSearchData(newValues);
                                  setSubmit(true);
                                  sessionStorage.setItem(
                                    'ClientManagement',
                                    JSON.stringify(newValues),
                                  );
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      variant="outlined"
                                      margin="dense"
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      label="Type"
                                      placeholder="Select Type"
                                      className={` ${classes.labelName}`}
                                    />
                                  </div>
                                )}
                              />
                            </Grid>
                          ) : null}
                          {values?.organizationType?.value === 'Service-Client' ? (
                            <>
                              <Grid item xs={3} md={4} className="form-group close-icon label-overflow-md">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="companyName"
                                  id="companyName"
                                  size="small"
                                  value={values.companyName}
                                  freeSolo
                                  options={companyAPIdata || []}
                                  getOptionLabel={(option) => option.companyName || ''}
                                  filterOptions={(options) => {
                                    const inputValue = values?.companyName || '';
                                    if (!inputValue) return options || [];
                                    const filteredOptions = (options || []).filter((option) =>
                                      option.companyName.toLowerCase().includes(inputValue.companyName.toLowerCase())
                                    );
                                    return filteredOptions;
                                  }}
                                  onInputChange={(e, value) => {
                                    if (typeof value === 'string') {
                                      setFieldValue('companyName', { companyName: value });
                                    } else {
                                      setFieldValue('companyName', value);
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        label={`${TENANTS_REVONE_COMPANIES} Name`}
                                        placeholder={`Select ${TENANTS_REVONE_COMPANIES} Name`}
                                        className={` ${classes.labelName}`}
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={3} md={4} className="form-group close-icon">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="corporateName"
                                  id="corporateName"
                                  size="small"
                                  value={values.corporateName}
                                  options={corporateAPIdata || []}
                                  getOptionLabel={(option) => {
                                    return option.corporateName || '';
                                  }}
                                  freeSolo
                                  onInputChange={(e, value) => {
                                    if (typeof value === 'string') {
                                      setFieldValue('corporateName', {corporateName: value});
                                    } else {
                                      setFieldValue('corporateName', value);
                                    }
                                  }}
                                  filterOptions={(options) => {
                                    const inputValue = values?.corporateName || '';
                                    if (!inputValue) return options || [];
                                    const filteredOptions = (options || []).filter((option) =>
                                      option?.corporateName?.toLowerCase().includes(inputValue?.corporateName?.toLowerCase())
                                    );
                                    return filteredOptions;
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        label="Corporate Name"
                                        placeholder="Select Corporate Name"
                                        className={` ${classes.labelName}`}
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={3} md={4} className="form-group close-icon">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="siteName"
                                  id="siteName"
                                  size="small"
                                  value={values.siteName}
                                  freeSolo
                                  options={siteAPIdata || []}
                                  getOptionLabel={(option) => {
                                    return option.siteName || '';
                                  }}
                                  onInputChange={(e, value) => {
                                    if (typeof value === 'string') {
                                      setFieldValue('siteName', {siteName: value});
                                    } else {
                                      setFieldValue('siteName', value);
                                    }
                                  }}
                                  filterOptions={(options) => {
                                    const inputValue = values?.siteName || '';
                                    if (!inputValue) return options || [];
                                    const filteredOptions = (options || []).filter((option) =>
                                      option?.siteName?.toLowerCase().includes(inputValue?.siteName?.toLowerCase())
                                    );
                                    return filteredOptions;
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        label="Site Name"
                                        placeholder="Select Site Name"
                                        className={` ${classes.labelName}`}
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={3} md={4} className="form-group">
                                <TextField
                                  className={` ${classes.labelName}`}
                                  margin="dense"
                                  variant="outlined"
                                  placeholder={`Enter Client Name`}
                                  label="Client Name"
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  name="clientName"
                                  value={values?.clientName}
                                  onChange={(e) => {
                                    setFieldValue('clientName', e.target.value);
                                  }}
                                  onBlur={handleBlur}
                                  fullWidth
                                  touched={touched.clientName}
                                  error={Boolean(touched.clientName && errors.clientName)}
                                />
                              </Grid>
                              <Grid item xs={3} md={4} className="form-group">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                    popper: classes.popper,
                                  }}
                                  name="clientNumber"
                                  id="clientNumber"
                                  size="small"
                                  value={values.clientNumber}
                                  freeSolo
                                  options={clientNumberAPIdata || []}
                                  getOptionLabel={(option) => {
                                    return option || '';
                                  }}
                                  onInputChange={(e, value) => {
                                    setFieldValue('clientNumber', value);
                                  }}
                                  filterOptions={(options) => {
                                    const inputValue = values?.clientNumber || '';
                                    if (!inputValue) return options || [];
                                    const filteredOptions = (options || []).filter((option) =>
                                      option?.toLowerCase().includes(inputValue?.toLowerCase())
                                    );
                                    return filteredOptions;
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        label="Client Code"
                                        placeholder="Enter Client Code"
                                        className={` ${classes.labelName}`}
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={3} md={4} className="form-group">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="clientClass"
                                  id="clientClass"
                                  size="small"
                                  value={values.clientClass}
                                  options={dropDownData?.CLIENT_CLASS || []}
                                  getOptionLabel={(option) => {
                                    return option && option.valueCode && option.value ?
                                      option.valueCode + ' - ' + option.value :
                                      option.value === null ?
                                        option.valueCode :
                                        '';
                                  }}
                                  onChange={(e, value) => {
                                    setFieldValue('clientClass', value);
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        className={` ${classes.labelName}`}
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        label="Client Class"
                                        placeholder="Select Client Class"
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>

                              <Grid item xs={3} md={4} className="form-group">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="status"
                                  id="status"
                                  size="small"
                                  value={values.status}
                                  options={StatusOptions}
                                  getOptionLabel={(option) => {
                                    return option && option?.value;
                                  }}
                                  onChange={(e, value) => {
                                    handleChange(e);
                                    setFieldValue('status', value);
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        label="Status"
                                        placeholder="Select Status"
                                        className={` ${classes.labelName}`}
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>
                            </>
                          ) : values?.organizationType?.value === 'Site' ? (
                            <>
                              <Grid item xs={3} md={4} className="form-group">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="corporateName"
                                  id="corporateName"
                                  size="small"
                                  value={values.corporateName}
                                  options={corporateAPIdata || []}
                                  getOptionLabel={(option) => {
                                    return option.corporateName || '';
                                  }}
                                  freeSolo
                                  onInputChange={(e, value) => {
                                    if (typeof value === 'string') {
                                      setFieldValue('corporateName', {corporateName: value});
                                    } else {
                                      setFieldValue('corporateName', value);
                                    }
                                  }}
                                  filterOptions={(options) => {
                                    const inputValue = values?.corporateName || '';
                                    if (!inputValue) return options || [];
                                    const filteredOptions = (options || []).filter((option) =>
                                      option?.corporateName?.toLowerCase().includes(inputValue?.corporateName?.toLowerCase())
                                    );
                                    return filteredOptions;
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        label="Corporate Name"
                                        placeholder="Select Corporate Name"
                                        className={` ${classes.labelName}`}
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={3} md={4} className="form-group">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="siteName"
                                  id="siteName"
                                  size="small"
                                  value={values.siteName}
                                  freeSolo
                                  options={siteAPIdata || []}
                                  getOptionLabel={(option) => {
                                    return option.siteName || '';
                                  }}
                                  onInputChange={(e, value) => {
                                    if (typeof value === 'string') {
                                      setFieldValue('siteName', {siteName: value});
                                    } else {
                                      setFieldValue('siteName', value);
                                    }
                                  }}
                                  filterOptions={(options) => {
                                    const inputValue = values?.siteName || '';
                                    if (!inputValue) return options || [];
                                    const filteredOptions = (options || []).filter((option) =>
                                      option?.siteName?.toLowerCase().includes(inputValue?.siteName?.toLowerCase())
                                    );
                                    return filteredOptions;
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        label="Site Name"
                                        placeholder="Select Site Name"
                                        className={` ${classes.labelName}`}
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>
                            </>
                          ) : values?.organizationType?.value === 'Company' ? (
                            <>
                              <Grid item xs={3} md={6} lg={4} xl={4} className="form-group close-icon ">
                                <Autocomplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="companyName"
                                  id="companyName"
                                  size="small"
                                  value={values?.companyName}
                                  options={companyAPIdata || []}
                                  getOptionLabel={(option) => {
                                    return option.companyName || '';
                                  }}
                                  freeSolo
                                  onInputChange={(e, value) => {
                                    if (typeof value === 'string') {
                                      setFieldValue('companyName', {companyName: value});
                                    } else {
                                      setFieldValue('companyName', value);
                                    }
                                  }}
                                  filterOptions={(options) => {
                                    const inputValue = values?.companyName || '';
                                    if (!inputValue) return options || [];
                                    const filteredOptions = (options || []).filter((option) =>
                                      option.companyName.toLowerCase().includes(inputValue.companyName.toLowerCase())
                                    );
                                    return filteredOptions;
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        label={`${TENANTS_REVONE_COMPANIES} Name`}
                                        placeholder={`Select ${TENANTS_REVONE_COMPANIES} Name`}
                                        className={`  ${classes.labelName}`}
                                      />
                                    </div>
                                  )}
                                />
                              </Grid>
                            </>
                          ) : values?.organizationType?.value === 'Corporate' ? (
                            <Grid item xs={3} md={4} className="form-group">
                              <Autocomplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="corporateName"
                                id="corporateName"
                                size="small"
                                value={values?.corporateName}
                                options={corporateAPIdata || []}
                                getOptionLabel={(option) => {
                                  return option.corporateName || '';
                                }}
                                freeSolo
                                onInputChange={(e, value) => {
                                  if (typeof value === 'string') {
                                    setFieldValue('corporateName', {corporateName: value});
                                  } else {
                                    setFieldValue('corporateName', value);
                                  }
                                }}
                                filterOptions={(options) => {
                                  const inputValue = values?.corporateName || '';
                                  if (!inputValue) return options || [];
                                  const filteredOptions = (options || []).filter((option) =>
                                    option?.corporateName?.toLowerCase().includes(inputValue?.corporateName?.toLowerCase())
                                  );
                                  return filteredOptions;
                                }}
                                renderInput={(params) => (
                                  <div className="select-field close-icon">
                                    <GuiTextField
                                      {...params}
                                      variant="outlined"
                                      margin="dense"
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      label="Corporate Name"
                                      placeholder="Select Corporate Name"
                                      className={` ${classes.labelName}`}
                                    />
                                  </div>
                                )}
                              />
                            </Grid>
                          ) : null}
                          {/* <Grid item xs={3} className="form-group">
                            <Autocomplete
                              classes={`${{
                                // popper: classes.popper,
                                option: classes.option,
                              }}`}
                              name="status"
                              id="status"
                              size="small"
                              options={StatusOptions}
                              required
                              value={values.status}
                              getOptionLabel={(option) => {
                                return option && option?.value;
                              }}
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue("status", value);
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    // className={` ${classes.labelName} ${classes.selectLabel}`}
                                    variant="standard"
                                    margin="dense"
                                    InputLabelProps={{ shrink: true }}
                                    label="Status"
                                    placeholder="Select Status"
                                    // className={` ${classes.labelName} ${classes.selectLabel}`}
                                  />
                                </div>
                              )}
                            />
                          </Grid> */}
                          {/* <Grid item xs={3} className="form-group">
                            <Autocomplete
                              classes={{
                                option: classes.option,
                              }}
                              name="status"
                              id="status"
                              size="small"
                              value={values.status}
                              options={StatusOptions}
                              getOptionLabel={(option) => {
                                return option && option?.value;
                              }}
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue("status", value);
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    // InputLabelProps={{
                                    //   shrink: true,
                                    // }}
                                    label="Status"
                                    placeholder="Select Status"
                                    // className={` ${classes.labelName} ${classes.selectLabel}`}
                                  />
                                </div>
                              )}
                            />
                          </Grid> */}
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields ">
                      <Button
                        variant="outlined"
                        type="button"
                        className={`mr-1 reset-btn ${classes.buttonRoot}`}
                        onClick={() => {
                          setFieldValue('corporateName', {});
                          setFieldValue('companyName', {});
                          setFieldValue('siteName', {});
                          setFieldValue('clientName', '');
                          setFieldValue('clientClass', '');
                          setFieldValue('clientNumber', '');
                          setFieldValue('status', {key: 'A', value: 'All'});
                          const newValues = {
                            ...values,
                            corporateName: '',
                            companyName: '',
                            siteName: '',
                            clientName: '',
                            clientClass: '',
                            clientNumber: '',
                            status: 'All',
                          }
                          setSearchData(newValues);
                          if(tenants){
                            sessionStorage.setItem(
                              'Tenants',
                              JSON.stringify(newValues),
                            );
                          } else if(!tenants){
                            sessionStorage.setItem(
                              'ClientManagement',
                              JSON.stringify(newValues),
                            );
                          }
                          setSubmit(true);
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Search
                      </Button>
                    </div>
                  </Form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      <ResultsTable
        setEdit={setEdit}
        searchData={searchData}
        isSubmit={isSubmit}
        setSubmit={setSubmit}
        setTabValue={setTabValue}
        setOrgType={setOrgType}
        setId={setId}
        tenants={tenants}
        organizationAccess={organizationAccess}
        setSiteTableData={setSiteTableData}
      />
    </>
  );
};

export default Organization;
